import { API_URLS } from '../../constants/apiConstants';
import { BAND_ITEM_SIZE, BAND_TYPE } from '../../constants/bandConstants';
import { IMAGE_SERVER_URL } from '../common/apiConfig';
import convertImageUrl from './convertImageUrl';
import getProgramMovieEpisodeChannel from './getProgramMovieEpisodeChannel';
/**
 * 띠 타입, 요청 URL, 응답값으로부터 포스터 이미지를 가져옵니다.
 *
 * @param bandType
 * @param bandApiUrl
 * @param itemResponse
 * @param isResize
 */
var getPosterUrl = function (bandType, bandApiUrl, itemResponse, isResize) {
    var _a;
    if (isResize === void 0) { isResize = true; }
    var posterUrl = '';
    switch (bandType) {
        case BAND_TYPE.PORT:
        case BAND_TYPE.LIST_PORT:
        case BAND_TYPE.SEARCH_RECOMMEND_PORT:
        case BAND_TYPE.LAND:
        case BAND_TYPE.PRANK:
        case BAND_TYPE.EPI: {
            var _b = getProgramMovieEpisodeChannel(bandApiUrl, itemResponse), program = _b.program, movie = _b.movie;
            if (movie) {
                var image = movie.image;
                var images = image.reduce(function (images, image) {
                    // eslint-disable-next-line no-param-reassign
                    images[image.code] = image.url;
                    return images;
                }, {});
                var posterUrls = [];
                var CAIM2100 = images.CAIM2100, CAIM0500 = images.CAIM0500, CAIM0800 = images.CAIM0800, CAIM2200 = images.CAIM2200, CAIM2300 = images.CAIM2300;
                if (CAIM2100) {
                    posterUrls.push(CAIM2100);
                }
                else if (CAIM0500) {
                    posterUrls.push(CAIM0500);
                }
                else if (CAIM0800) {
                    posterUrls.push(CAIM0800);
                }
                if (CAIM2200 != null) {
                    posterUrls.push(CAIM2200);
                }
                if (CAIM2300 != null) {
                    posterUrls.push(CAIM2300);
                }
                posterUrl = posterUrls[Math.floor(Math.random() * posterUrls.length)];
            }
            else if (program) {
                var image = program.image;
                var images = image.reduce(function (images, image) {
                    // eslint-disable-next-line no-param-reassign
                    images[image.code] = image.url;
                    return images;
                }, {});
                if (bandType === BAND_TYPE.LAND) {
                    var CAIP0400 = images.CAIP0400, CAIP0500 = images.CAIP0500, CAIP0200 = images.CAIP0200, CAIC1500 = images.CAIC1500;
                    posterUrl = CAIP0400 || CAIP0500 || CAIP0200 || CAIC1500;
                }
                else {
                    var CAIP0900 = images.CAIP0900, CAIP2300 = images.CAIP2300, CAIP2400 = images.CAIP2400;
                    var posterUrls = [];
                    if (CAIP0900) {
                        posterUrls.push(CAIP0900);
                    }
                    if (CAIP2300) {
                        posterUrls.push(CAIP2300);
                    }
                    if (CAIP2400) {
                        posterUrls.push(CAIP2400);
                    }
                    posterUrl = posterUrls[Math.floor(Math.random() * posterUrls.length)];
                }
            }
            break;
        }
        case BAND_TYPE.SEARCH_LAND:
        case BAND_TYPE.SEARCH_PORT:
        case BAND_TYPE.SEARCH_LIST_PORT: {
            var _c = itemResponse, mastCd = _c.mast_cd, webUrl4 = _c.web_url4, webUrl = _c.web_url;
            posterUrl = mastCd.startsWith('P') ? webUrl4 : webUrl;
            break;
        }
        case BAND_TYPE.SEARCH_AUTO_RESULT: {
            var _d = itemResponse, mastCd = _d.mast_cd, webUrl4 = _d.web_url4, webUrl = _d.web_url;
            posterUrl = mastCd.startsWith('P') ? webUrl4 : webUrl;
            break;
        }
        case BAND_TYPE.BAN1:
        case BAND_TYPE.BAN2:
        case BAND_TYPE.BAN3: {
            var highlightResult = itemResponse;
            if (highlightResult.content_type === 'banner') {
                var bannerImageUrl = itemResponse.content.banner_image_url;
                // banner_image_url 없으면 mappingImageUrl 에 넣어주는 경우가 있다
                posterUrl = bannerImageUrl || itemResponse.mapping_image_url;
            }
            else if (highlightResult.content_type === 'live') {
                posterUrl = highlightResult.mapping_image_url || '';
            }
            break;
        }
        case BAND_TYPE.CHA: {
            var logoImg2 = itemResponse.logo_img2;
            posterUrl = logoImg2;
            break;
        }
        case BAND_TYPE.META_EPI:
        case BAND_TYPE.META_PROGRAM:
        case BAND_TYPE.PLAYER_META_PROGRAM:
        case BAND_TYPE.META_MOVIE: {
            var _e = getProgramMovieEpisodeChannel(bandApiUrl, itemResponse), program = _e.program, movie = _e.movie, episode = _e.episode;
            if (movie) {
                var movieImage = (movie || {}).image;
                var movieImages = movieImage === null || movieImage === void 0 ? void 0 : movieImage.reduce(function (movieImages, movieImage) {
                    // eslint-disable-next-line no-param-reassign
                    movieImages[movieImage.code] = movieImage.url;
                    return movieImages;
                }, {});
                var _f = movieImages || {}, CAIM0400 = _f.CAIM0400, CAIM0700 = _f.CAIM0700, CAIM0200 = _f.CAIM0200;
                posterUrl = CAIM0400 || CAIM0700 || CAIM0200;
            }
            else if (bandApiUrl === API_URLS.EPISODES || bandApiUrl === API_URLS.FREQUENCY_PROGRAM) {
                // 에피소드 회차
                var programImage = (program || {}).image;
                var episodeImage = (episode || {}).image;
                var programImages = programImage === null || programImage === void 0 ? void 0 : programImage.reduce(function (programImages, programImage) {
                    // eslint-disable-next-line no-param-reassign
                    programImages[programImage.code] = programImage.url;
                    return programImages;
                }, {});
                var episodeImages = episodeImage === null || episodeImage === void 0 ? void 0 : episodeImage.reduce(function (episodeImages, episodeImage) {
                    // eslint-disable-next-line no-param-reassign
                    episodeImages[episodeImage.code] = episodeImage.url;
                    return episodeImages;
                }, {});
                var CAIE0400 = (episodeImages || {}).CAIE0400;
                var _g = programImages || {}, CAIP0400 = _g.CAIP0400, CAIP0500 = _g.CAIP0500, CAIP0200 = _g.CAIP0200, CAIP2100 = _g.CAIP2100, CAIP2200 = _g.CAIP2200, CAIC1500 = _g.CAIC1500;
                posterUrl = CAIE0400 || CAIP0400 || CAIP0500 || CAIP0200 || CAIP2100 || CAIP2200 || CAIC1500;
            }
            else if (bandApiUrl === API_URLS.RECOMMEND_CATEGORY) {
                var programImage = (program || {}).image;
                var programImages = programImage === null || programImage === void 0 ? void 0 : programImage.reduce(function (programImages, programImage) {
                    // eslint-disable-next-line no-param-reassign
                    programImages[programImage.code] = programImage.url;
                    return programImages;
                }, {});
                var _h = programImages || {}, CAIP0400 = _h.CAIP0400, CAIP0500 = _h.CAIP0500, CAIP0200 = _h.CAIP0200, CAIC1500 = _h.CAIC1500;
                posterUrl = CAIP0400 || CAIP0500 || CAIP0200 || CAIC1500;
            }
            break;
        }
        default:
    }
    if (isResize) {
        return convertImageUrl(IMAGE_SERVER_URL + posterUrl, (_a = BAND_ITEM_SIZE[bandType].posterWidth) !== null && _a !== void 0 ? _a : BAND_ITEM_SIZE[bandType].width);
        // return `${IMAGE_SERVER_URL + posterUrl}/dims/resize/F_webp,${BAND_ITEM_SIZE[bandType].posterWidth ?? BAND_ITEM_SIZE[bandType].width}`;
    }
    return posterUrl || '';
};
export default getPosterUrl;
